import * as Sentry from "@sentry/react";
import { SENTRY_LOG_LEVEL } from "./sentryEnums";
import {
  getLocalStorageElement,
  LOCAL_STORAGE_KEYS,
} from "@kivunova/kivufrontendcommon";

export const captureSentryException = (
  exceptionName: string,
  error: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  userId?: string,
  companyId?: string,
  storeId?: string,
  options?: { [key: string]: string },
) => {
  Sentry.withScope((scope) => {
    scope.setExtra("additionalInfo", {
      companyId,
      userId,
      storeId,
      ...(options ? options : {}),
      userAgent: navigator.userAgent,
      language: getLocalStorageElement(LOCAL_STORAGE_KEYS.LANG),
      screen: {
        width: window.screen.width,
        height: window.screen.height,
        pixelRatio: window.devicePixelRatio,
      },
      pathName: window.location.pathname,
      origin: window.location.origin,
      href: window.location.href,
    });

    Sentry.captureException(
      new Error(exceptionName, {
        cause: error,
      }),
    );
  });
};

export const sendSentryLog = (
  logLevel: SENTRY_LOG_LEVEL,
  logMessage: string,
  userId?: string,
  companyId?: string,
  storeId?: string,
  options?: { [key: string | number]: string | number },
) => {
  const finalOptions = {
    companyId,
    userId,
    storeId,
    ...(options ? options : {}),
    userAgent: navigator.userAgent,
    language: getLocalStorageElement(LOCAL_STORAGE_KEYS.LANG),
    screen: {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio,
    },
    pathName: window.location.pathname,
    origin: window.location.origin,
    href: window.location.href,
  };

  if (logLevel === SENTRY_LOG_LEVEL.FATAL) {
    Sentry.logger.fatal(logMessage, finalOptions);
  } else if (logLevel === SENTRY_LOG_LEVEL.WARNING) {
    Sentry.logger.warn(logMessage, finalOptions);
  } else if (logLevel === SENTRY_LOG_LEVEL.ERROR) {
    Sentry.logger.error(logMessage, finalOptions);
  } else if (logLevel === SENTRY_LOG_LEVEL.TRACE) {
    Sentry.logger.trace(logMessage, finalOptions);
  } else {
    Sentry.logger.info(logMessage, finalOptions);
  }
};
